import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Loader from "@irati/ui/src/Loading/Loader"
import {greys} from "@irati/ui/src/global/colors"

export const Overlay = styled.div`
  background-color: ${greys.white};
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`

const Wrapper = styled.div`
  position: relative;
`

const LoaderWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`

const LoadingOverlay = ({loading, children}) => {
  return (
    <Wrapper>
      {children}
      {loading && (
        <>
          <Overlay />
          <LoaderWrapper>
            <Loader />
          </LoaderWrapper>
        </>
      )}
    </Wrapper>
  )
}

LoadingOverlay.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired
}

LoadingOverlay.defaultProps = {
  loading: false
}

export default LoadingOverlay
